module.exports = __webpack_public_path__ + "img/1.52bd9d6c.jpg";